'use client';
import React from 'react';
import UserDashboard from './components/UserDashboard';

export default function DashboardPage() {
  return <UserDashboard />;
}
